import { createBrowserRouter, Outlet } from "react-router-dom";
import App from "../App";
import Home from "../pages/Home";
import AboutCompany from "../pages/AboutCompany";
import ProjectsList from "../pages/ProjectsList";
import GreenHome from "../pages/GreenHome";
import Nikea from "../pages/Nikea";
import Apartments from "../pages/Apartments";
import VisualSearchBlock from "../pages/VisualSearch";
import VisualSearchFloor from "../pages/VisualSearchFloor";
import Flat from "../pages/Flat";
import CompanyView from "../pages/CompanyView";
import News from "../pages/News";
import NewsDetails from "../pages/NewsDetails";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: "about",
        element: <AboutCompany />,
      },
      {
        path: "company-view",
        element: <CompanyView />,
      },
      {
        path: "news",
        element: <Outlet />, // Empty wrapper for nested routes
        children: [
          {
            path: "",
            element: <News />,
          },
          { path: ":id", element: <NewsDetails /> },
        ],
      },
      {
        path: "projects",
        element: <Outlet />, // Empty wrapper for nested routes
        children: [
          {
            path: "",
            element: <ProjectsList />, // Default route for '/projects'
          },
          {
            path: "greenhome",
            element: <Outlet />,
            children: [
              {
                path: "",
                element: <GreenHome />, // Default route for '/projects'
              },
              {
                path: "apartments",
                element: <Outlet />,
                children: [
                  {
                    path: "",
                    element: <Apartments />, // search by fillters
                  },
                  {
                    path: "floor/:floorId/apartment/:id",
                    element: <Flat />,
                  },
                ],
              },
              {
                path: "block",
                element: <Outlet />,
                children: [
                  {
                    path: "",
                    element: <VisualSearchBlock />, //ვიზუალურად ძებნა კორპუსის ხედი
                  },
                  {
                    path: "floor",
                    element: <Outlet />,
                    children: [
                      {
                        path: ":floorId",
                        element: <VisualSearchFloor />, // ვიზუალურად ძებნა სართულის ჭრილი
                      },
                      {
                        path: ":id",
                        element: <Flat />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: "nikea",
            element: <Outlet />,
            children: [
              {
                path: "",
                element: <Nikea />,
              },
              {
                path: "apartments",
                element: <Outlet />,
                children: [
                  {
                    path: "",
                    element: <Apartments />,
                  },
                  {
                    path: "floor/:floorId/apartment/:id",
                    element: <Flat />,
                  },
                ],
              },
              {
                path: "block",
                element: <Outlet />,
                children: [
                  {
                    path: "",
                    element: <VisualSearchBlock />,
                  },
                  {
                    path: "floor",
                    element: <Outlet />,
                    children: [
                      {
                        path: ":floorId",
                        element: <VisualSearchFloor />,
                      },
                      {
                        path: ":id",
                        element: <Flat />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
]);

export default router;
